import { Box } from 'theme-ui'

export const StopPropogation = ({ children }) => {
  return <Box onClick={e => e.stopPropagation()}>{children}</Box>
}
